import mediaQueries, { deviceTypes } from '@styles/mediaQueries';

export type IDeviceTypes = keyof typeof deviceTypes;

export function getDevice(): IDeviceTypes {
  if (typeof window !== 'undefined' && window.matchMedia) {
    const mediaQueryString = mediaQueries.maxWidth(mediaQueries.sm);
    const { matches } = window.matchMedia(mediaQueryString);

    if (matches) return 'mobile';
  }
  return 'desktop';
}
